import React from "react";
import XIcon from "../../assets/XIcon";
import FooterEmailIcon from "../../assets/images/footerEmail.svg";
import FooterGroupIcon from "../../assets/images/footerGroup.svg";
import FooterPhoneIcon from "../../assets/images/footerPhone.svg";

import useFooterStyle from "./style";

export default function Footer() {
  const classes = useFooterStyle();

  const handleCookieSettingsClick = (
    event: React.MouseEvent<HTMLAnchorElement>
  ) => {
    event.preventDefault();
    window.dispatchEvent(new Event("showCookiePreferences"));
  };

  return (
    <footer className={classes.footer}>
      <div className={classes.footerContainer}>
        <div className={classes.footerTop}>
          <div className={classes.footerItemLeft}>
            <div className={classes.contactUsFooterSection}>
              <div className={classes.contactUsBlock}>
                <h4 className={classes.footerH}>Contact Us:</h4>
                <ul className={classes.contactUsFooterList}>
                  <li>
                    <a
                      href="mailto:support@sugarcribs.com"
                      style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        textDecoration: "underline",
                      }}
                      className={classes.link}
                    >
                      <img
                        src={FooterEmailIcon}
                        alt="Email"
                        style={{
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      support@sugarcribs.com
                    </a>
                  </li>
                  <li>
                    <a
                      rel="nofollow noreferrer noopener"
                      href="https://www.ccbillcomplaintform.com/ccbill/form/CCBillContentRemovalRequest1/formperma/sBK2jfIoZWAFw2hRRt5Rv2PQncscFzpvOH6bPcwopas"
                      style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      className={classes.link}
                      target="_blank"
                    >
                      <img
                        src={FooterGroupIcon}
                        alt="Report"
                        style={{
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      Report content
                    </a>
                  </li>
                </ul>
              </div>
              <div className={classes.mobileFollowUsWrapper}>
                <h4 className={classes.mobileFollowUsHeader}>Follow Us:</h4>
                <a
                  href="https://x.com/sugarcribs"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on X"
                  className={classes.mobileXIconLink}
                >
                  <XIcon
                    style={{
                      color: "#FE5A97",
                      width: "32px",
                      height: "32px",
                    }}
                  />
                </a>
              </div>
            </div>

            <div className={classes.footerSection}>
              <div className={classes.contactCcbillBlock}>
                <h4 className={classes.footerHWithMargin}>Contact CCBill:</h4>
                <ul className={classes.ccbillFooterList}>
                  <li>
                    <a
                      href="https://support.ccbill.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        textDecoration: "underline",
                      }}
                      className={classes.link}
                    >
                      <img
                        src={FooterEmailIcon}
                        alt="Email"
                        style={{
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      support.ccbill.com
                    </a>
                  </li>
                  <li>
                    <a
                      href="tel:8885969279"
                      style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      className={classes.link}
                    >
                      <img
                        src={FooterPhoneIcon}
                        alt="Phone"
                        style={{
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      888.596.9279
                    </a>
                  </li>
                </ul>
              </div>
              <div className={classes.mobileCookieReferralWrapper}>
                <a
                  href="#cookie-settings"
                  style={{ color: "#FFFFFFCC" }}
                  className={classes.mobileCookieSettingsLink}
                  onClick={handleCookieSettingsClick}
                >
                  Cookie Settings
                </a>
                <a
                  href="/referral"
                  style={{ color: "#FFFFFFCC" }}
                  className={classes.mobileReferralProgramLink}
                >
                  Referral Program
                </a>
              </div>
            </div>
          </div>

          <div className={classes.footerItemRight}>
            <div className={classes.legalFooterSection}>
              <h4 className={classes.legalFooterH}>Legal:</h4>
              <ul className={classes.legalFooterList}>
                <li>
                  <a href="/complaints-policy" className={classes.link}>
                    Complaints and Takedown Policy
                  </a>
                </li>
                <li>
                  <a href="/privacy-policy" className={classes.link}>
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/refund-policy" className={classes.link}>
                    Refund Policy
                  </a>
                </li>
                <li>
                  <a href="/acceptable-use-policy" className={classes.link}>
                    Acceptable Use Policy
                  </a>
                </li>
                <li>
                  <a href="/DMCA-takedown-policy" className={classes.link}>
                    DMCA Takedown
                  </a>
                </li>
                <li>
                  <a href="/terms-of-service" className={classes.link}>
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a href="/kyc-aml-compliance-policy" className={classes.link}>
                    KYC / AML Compliance Policy
                  </a>
                </li>
                <li>
                  <a href="/cookie-policy" className={classes.link}>
                    Cookie Policy
                  </a>
                </li>
              </ul>
            </div>

            <div className={classes.followUsFooterSection}>
              <h4 className={classes.desktopFollowUsHeader}>Follow Us:</h4>

              <a
                href="https://x.com/sugarcribs"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on X"
                className={classes.xIconLink}
              >
                <XIcon
                  style={{
                    color: "#FE5A97",
                    width: "32px",
                    height: "32px",
                  }}
                />
              </a>

              <div className={classes.desktopCookieReferralLinks}>
                <a
                  href="#cookie-settings"
                  style={{ color: "#FFFFFFCC" }}
                  className={classes.link}
                  onClick={handleCookieSettingsClick}
                >
                  Cookie Settings
                </a>

                <a
                  href="/referral"
                  style={{ color: "#FFFFFFCC" }}
                  className={classes.link}
                >
                  Referral Program
                </a>
              </div>

              <div className={classes.followUsSection}>
                <div className={classes.followUsItems}>
                  <a
                    href="https://www.rtalabel.org/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    aria-label="Restricted To Adults (RTA)"
                    className={classes.badgeLink}
                  >
                    <img
                      src="/assets/120x60_RTA-5042-1996-1400-1577-RTA-B-VERIFIED.gif"
                      alt="RTA — Restricted To Adults"
                      loading="lazy"
                      className={classes.badgeImg}
                    />
                  </a>

                  <a
                    href="https://www.safelabeling.org/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    aria-label="SafeLabeling"
                    className={classes.badgeLink}
                  >
                    <img
                      src="/assets/safe-labeling-compliant.gif"
                      alt="SafeLabeling"
                      loading="lazy"
                      className={classes.badgeImg}
                    />
                  </a>
                </div>
                <p className={classes.footerP}>
                  <a
                    href="/compliance-statement"
                    className={classes.complianceLink}
                  >
                    18 U.S.C. 2257 Record-Keeping Requirements Compliance
                    Statement
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.footerHelp}>
        <div className={classes.footerHelpContainer}>
          TOPV1 LLC Las Vegas, Nevada, United States ©{" "}
          {new Date().getFullYear()} SugarCribs. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
